/* eslint-disable */
export default {
  order: 3,
  header: [
    {
      category: '概览',
      item: [
        {
          title: '',
          list: [
            {
              name: '什么是 EnOS',
              url: '/docs/enos/zh_CN/2.4.4/overview/enos_introduction.html'
            },
            {
              name: 'EnOS 优势',
              url: '/docs/enos/zh_CN/2.4.4/overview/advantage.html'
            },
            {
              name: '关键概念',
              url: '/docs/enos/zh_CN/2.4.4/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: '产品文档',
      item: [
        {
          title: '应用构建',
          list: [
            {
              name: '应用门户',
              url: '/docs/app-portal/zh_CN/2.4.4/overview.html'
            },
            {
              name: 'EnOS 移动端',
              url: '/docs/maf/zh_CN/2.4.4/intro/overview.html'
            },
            {
              name: '数字孪生可视化',
              url: '/docs/dtv/zh_CN/2.4.4/overview.html'
            },
            {
              name: '统一监测',
              url: '/docs/monitor/zh_CN/2.4.4/overview/monitor_overview.html'
            },
            {
              name: '报表工具',
              url: '/docs/reporting/zh_CN/2.4.4/overview.html'
            },
            {
              name: '工作管理',
              url: '/docs/wmt/zh_CN/2.4.4/about.html'
            },
            {
              name: '集群控制',
              url: '/docs/control/zh_CN/2.4.4/overview.html'
            },
            {
              name: '指标管理',
              url: '/docs/metric-management/zh_CN/2.4.4/overview/metrics_overview.html'
            }
          ]
        },
        {
          title: '数据管理',
          list: [
            {
              name: '数据资产管理',
              url: '/docs/data-asset-mgmt/zh_CN/2.4.4/about/overview.html'
            },
            {
              name: '数据共享',
              url: '/docs/data-sharing/zh_CN/2.4.4/overview.html'
            },
            {
              name: '数据标准',
              url: '/docs/data-standards/zh_CN/2.4.4/about/overview.html'
            },
            {
              name: '数据策略',
              url: '/docs/data-policy/zh_CN/2.4.4/overview.html'
            },
            {
              name: '调度中心',
              url: '/docs/schedule-center/zh_CN/2.4.4/overview.html'
            },
            {
              name: '时序数据管理',
              url: '/docs/time-series-data/zh_CN/2.4.4/overview.html'
            },
            {
              name: '通用数据服务',
              url: '/docs/cds/zh_CN/2.4.4/overview.html'
            }
          ]
        },
        {
          title: '设备接入',
          list: [
            {
              name: '设备连接',
              url: '/docs/device-connection/zh_CN/2.4.4/learn/message_flow.html'
            },
            {
              name: '设备管理',
              url: '/docs/device-connection/zh_CN/2.4.4/learn/device_lifecycle_management.html'
            },
            {
              name: '设备数据集成服务',
              url: '/docs/device-integration/zh_CN/2.4.4/learn/device_integration_overview.html'
            },
            {
              name: '告警管理',
              url: '/docs/alarm-management/zh_CN/2.4.4/overview/about.html'
            },
            {
              name: '告警引擎',
              url: '/docs/alert/zh_CN/2.4.4/learn/alert_overview.html'
            },
            {
              name: '数据质量',
              url: '/docs/data-quality/zh_CN/2.4.4/overview/about.html'
            },
            {
              name: '设备预配置服务',
              url: '/docs/device-provisioning/zh_CN/2.4.4/overview/about.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: '查看所有产品',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/zh_CN/2.4.4'
      },
      showListInMobile: false
    },
    {
      category: '教程',
      item: [
        {
          title: '数据集成',
          list: [
            {
              name: '将模拟设备连接到 EnOS Cloud',
              url: '/docs/device-connection/zh_CN/2.4.4/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: '将模拟电表接入到 EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/tutorial/connecting_edge.html'
            },
            {
              name: 'PC 设备数据集成',
              url: '/docs/device-integration/zh_CN/2.4.4/howto/tutorial_pc_device_mgmt.html'
            }
          ]
        },
        {
          title: '数据开发',
          list: [
            {
              name: '评估风机设备的数据质量',
              url: '/docs/data-quality/zh_CN/2.4.4/tutorial.html'
            },
            {
              name: '开发光伏发电量、温度与辐照指标',
              url: '/docs/metric-management/zh_CN/2.4.4/tutorial/index.html'
            },
            {
              name: '自定义光伏场站发电量（上月同期）指标',
              url: '/docs/cds/zh_CN/2.4.4/tutorial/tutorial_solar.html'
            }
          ]
        },
        {
          title: '应用开发',
          list: [
            {
              name: '基于行业应用组件构建应用',
              url: '/docs/app-development/zh_CN/2.4.4/app_dev_workflow/index.html'
            },
            {
              name: '创建智能电池仪表盘',
              url: '/docs/dtv/zh_CN/2.4.4/tutorial/index.html'
            },
            {
              name: '创建可视化监测应用',
              url: '/docs/monitor/zh_CN/2.4.4/tutorial/overview.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: '查看所有教程',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/zh_CN/2.4.4/tutorial'
      },
      showListInMobile: false
    },
    {
      category: '开发资源',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/zh_CN/enos-apis/'
            },
            {
              name: 'SDK 和工具',
              url: 'https://developer.enos-iot.com/zh_CN/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: [
    {
      category: '数据集成',
      item: [
        {
          name: '将模拟设备连接到 EnOS Cloud',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/zh_CN/2.4.4/tutorial/connecting_device_simulated/index.html'
        },
        {
          name: '将个人电脑连接到 EnOS Cloud',
          description: '预计用时: 110 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/zh_CN/2.4.4/tutorial/connecting_pc/index.html'
        },
        {
          name: '将模拟电表通过 IEC104 规约接入到 EnOS Edge',
          description: '预计用时: 40 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/enos-edge/zh_CN/2.4.4/tutorial/connecting_edge.html'
        },
        {
          name: 'PC 设备数据集成',
          description: '预计用时: 40 分钟',
          image: 'assets/images/tutorial/dis_zh.png',
          url: '/docs/device-integration/zh_CN/2.4.4/howto/tutorial_pc_device_mgmt.html'
        }
      ]
    },
    {
      category: '数据开发',
      item: [
        {
          name: '评估风机设备的数据质量',
          description: '预计用时: 30 分钟',
          image: 'assets/images/tutorial/quality_zh.png',
          url: '/docs/data-quality/zh_CN/2.4.4/tutorial.html'
        },
        {
          name: '开发光伏发电量、温度与辐照指标',
          description: '预计用时: 120 分钟',
          image: 'assets/images/tutorial/metric_zh.png',
          url: '/docs/metric-management/zh_CN/2.4.4/tutorial/index.html'
        },
        {
          name: '自定义光伏场站发电量（上月同期）指标',
          description: '预计用时: 60 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/cds/zh_CN/2.4.4/tutorial/tutorial_solar.html'
        }
      ]
    },
    {
      category: '应用开发',
      item: [
        {
          name: '注册和管理应用',
          description: '预计用时: 40 分钟',
          image: 'assets/images/tutorial/app_zh.png',
          url: '/docs/app-development/zh_CN/2.4.4/app_management/managing_apps.html'
        },
        {
          name: '基于行业应用组件构建应用',
          description: '预计用时: 160 分钟',
          image: 'assets/images/tutorial/cbb_app_zh.png',
          url: '/docs/app-development/zh_CN/2.4.4/app_dev_workflow/index.html'
        },
        {
          name: '创建智能电池仪表盘',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/battery_dashboard_zh.png',
          url: '/docs/dtv/zh_CN/2.4.4/tutorial/index.html'
        },
        {
          name: '创建风电岗位工作台',
          description: '预计用时: 90 分钟',
          image: 'assets/images/tutorial/wind_dashboard_zh.png',
          url: '/docs/dtv/zh_CN/2.4.4/workbench/dtv.html'
        },
        {
          name: '创建纯水净化系统监控页面',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/water_monitoring_zh.png',
          url: '/docs/dtv/zh_CN/2.4.4/tutorial/monitor.html'
        },
        {
          name: '创建可视化监测应用',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/monitor_app_zh.png',
          url: '/docs/monitor/zh_CN/2.4.4/tutorial/overview.html'
        }
      ]
    }
  ]
};
